import { Spin, Table } from 'antd'
import React from 'react'
import { Card, CardBody } from 'reactstrap'

import { number, text } from '../../../helpers'

export default function CustomersReportFormatAgeContent({ report, loading }) {

	const columns = [
		{ title: 'Formato', dataIndex: 'format', render: t => text(t) },
		{ title: 'Rango de Edad', dataIndex: 'age_range', render: t => text(t) },
		{ title: 'Total Clientes', dataIndex: 'customers_count', render: t => number(t) },
		{ title: 'Total Ventas', dataIndex: 'total_sales', render: t => number(t) },
		{ title: 'Ticket Medio', dataIndex: 'ticket_medio', render: t => number(t) },
	]

	return (
		<React.Fragment>
			<Spin spinning={loading}>
				<Card>
					<CardBody>
						<Table 
							dataSource={report.data}
							columns={columns}
							size="small"
							rowKey={r => r.profile_id}
						/>
					</CardBody>
				</Card>
			</Spin>
		</React.Fragment>
	)
}